import { createSelector } from 'reselect';
import { activeSelector } from 'selectors/testTarget/offers/hideAutoReplenish/active/activeSelector';
import { isTestTargetReadySelector } from 'viewModel/selectors/testTarget/isTestTargetReadySelector';

const activeHideAutoReplenishSelector = createSelector(isTestTargetReadySelector, activeSelector, (testReady, active) => testReady && active);

export { activeHideAutoReplenishSelector };
